<template>
  <div>
    <!-- 表头 -->
    <div class="w-1200" style="margin-top: 40px">
      <!-- 表头 -->
      <img src="../assets/form_head.png" alt="图片" style="width: 100%; vertical-align: bottom" />
      <div style="width: 100%; height: 60px; background: #003e67">
        <p class="form_head_title">中国地区经销商汇总</p>
      </div>
    </div>

    <!-- 表单标题 -->
    <section class="w-1200 d-flex">
      <div class="form_title">
        <span class="form_title_text"> 区域 </span>
      </div>
      <div class="form_title">
        <span class="form_title_text"> 平台 </span>
      </div>
      <div class="form_title" style="border-right-width: 1px">
        <span class="form_title_text"> 店名 </span>
      </div>
    </section>

    <!-- 表单内容 -->
    <!-- 表单内容01 -->
    <section class="w-1200 d-flex" v-for="(item, index) in list" :key="index">
      <div class="form_contain">
        <span class="form_contain_text"> {{ item.province }} </span>
      </div>
      <div class="form_contain">
        <span class="form_contain_text"> {{ item.city }}</span>
      </div>
      <div class="form_contain" style="border-right: 1px solid #003e67">
        <span class="form_contain_text"> {{ item.name }} </span>
      </div>
    </section>
    <!-- 底部栏 -->
    <div style="height: 40px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          province: "线上",
          city: "天猫",
          name: "优曼德宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "绿动空间水族专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "幻倪旗舰店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "泰顺家居专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "求石宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "铭峰宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "鱼探宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "reptishow旗舰店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "大白宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "意品宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "天猫超市",
        },
        {
          province: "线上",
          city: "天猫",
          name: "三只猫宠物用品专营店",
        },
        {
          province: "线上",
          city: "天猫",
          name: "合肥大白宠物有限公司",
        },
        {
          province: "线上",
          city: "天猫国际",
          name: "南京齐立金网络科技有限公司",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "江南水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "上海长风水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "双鹰水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "宁波双喜专业水族器材店",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "猴哥爬爬",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "彩祺水族甄选",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "巨浪水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "JUWEL德国黑钻水族正品店",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "馨睿水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "坚强水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "天鸿水族",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "华韵七彩水族用品店",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "鲁南多多水族企业店",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "新派宠物",
        },
        {
          province: "线上",
          city: "淘宝",
          name: "大龙爬宠",
        },
        {
          province: "线上",
          city: "抖音",
          name: "优曼德专营店",
        },
        {
          province: "线上",
          city: "抖音",
          name: "彩祺甄选水族",
        },
        {
          province: "线上",
          city: "抖音",
          name: "广州懂明白宠物用品有限公司",
        },
        {
          province: "线上",
          city: "抖音",
          name: "旅顺口区聚鱼生态水族馆",
        },
        {
          province: "线上",
          city: "抖音",
          name: "百川水族优选店",
        },
        {
          province: "线上",
          city: "抖音",
          name: "小鹏说水族",
        },
        {
          province: "线上",
          city: "抖音",
          name: "龙鱼老孙的水族用品店",
        },
        // {
        //     province: "线上",
        //     city: "抖音",
        //     name: "箱龟狂热ah者",
        //   },
        {
          province: "线上",
          city: "抖音",
          name: "水族先生",
        },
        {
          province: "线上",
          city: "抖音",
          name: "Tetra德彩",
        },
        {
          province: "线上",
          city: "京东",
          name: "仟湖宠物生活专业店",
        },
        {
          province: "线上",
          city: "京东",
          name: "琦趣水族专营店",
        },
        {
          province: "线上",
          city: "京东",
          name: "宠小渔宠物用品专营店",
        },
        {
          province: "线上",
          city: "拼多多",
          name: "德彩水族专卖店",
        },
        {
          province: "广州",
          city: "线下实体店",
          name: "广州市荔湾区和合水族经营部",
        },
        {
          province: "上海",
          city: "线下实体店",
          name: "上海精彩堂",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "聚流品牌联合中原旗舰店-吉鱼水族",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "郑州源谷自然",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "洛阳G十二水族",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "开封睿美水族世界",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "周口睿美水族世界",
        },
        {
          province: "郑州",
          city: "线下实体店",
          name: "郑州亚马逊岛屿",
        },
        {
          province: "内蒙古",
          city: "线下实体店",
          name: "内蒙古沐鱼观赏水族",
        },
      ]
    };
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex;
}

.a-center {
  align-items: center;
}

.j-sb {
  justify-content: space-between;
}

.j-center {
  justify-content: center;
}

.w-1200 {
  width: 1200px;
  margin: 0 auto;
}

.form_head_title {
  padding: 0;
  margin: 0;
  font-size: 30px;
  line-height: 60px;
  letter-spacing: 1.5px;
  text-align: center;
  font-weight: 600;
  color: white;
}

.form_title {
  flex: 1;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #003e67;
  padding: 5px 15px;
  border-right-width: 0;
}

.form_title_text {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #003e67;
}

.form_contain {
  flex: 1;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #003e67;
  padding: 8px 10px;
  border-right-width: 0;
  border-top-width: 0;
}

.form_contain_text {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333;
}
</style>